import ApiClient from '../../../../api/ApiClient';

class CrmAPI extends ApiClient {
  constructor() {
    super('crm', { accountScoped: true });
  }

  getOverview(params = {}) {
    return window.axios.get(`${this.url}/overview`, { params });
  }

  getPipelines() {
    return window.axios.get(`${this.url}/pipelines`);
  }

  createPipeline(data) {
    return window.axios.post(`${this.url}/pipelines`, { pipeline: data });
  }

  updatePipeline(id, data) {
    return window.axios.put(`${this.url}/pipelines/${id}`, { pipeline: data });
  }

  deletePipeline(id) {
    return window.axios.delete(`${this.url}/pipelines/${id}`);
  }

  testPipelineWebhook(id, data = {}) {
    if (id) {
      return window.axios.post(`${this.url}/pipelines/${id}/test_webhook`, data);
    }
    return window.axios.post(`${this.url}/pipelines/test_webhook`, data);
  }

  getDeals(params = {}) {
    return window.axios.get(`${this.url}/deals`, { params });
  }

  createDeal(data) {
    return window.axios.post(`${this.url}/deals`, { deal: data });
  }

  updateDeal(id, data) {
    return window.axios.put(`${this.url}/deals/${id}`, { deal: data });
  }

  moveDealStage(id, { pipeline_stage_id, position, lost_reason }) {
    return window.axios.put(`${this.url}/deals/${id}/move_stage`, {
      pipeline_stage_id,
      position,
      lost_reason,
    });
  }

  deleteDeal(id) {
    return window.axios.delete(`${this.url}/deals/${id}`);
  }

  getStickers() {
    return window.axios.get(`${this.url}/stickers`);
  }

  createSticker(data) {
    return window.axios.post(`${this.url}/stickers`, { sticker: data });
  }

  deleteSticker(id) {
    return window.axios.delete(`${this.url}/stickers/${id}`);
  }
}

export default new CrmAPI();
